import React, { useEffect, useState } from 'react'
import { FormFooterButton, InputCss } from '../../../helper/CommonFunction';
import { ApiHandler } from '../../../helper/ApiHandler';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalLarge } from '../../../components/ModalComponets';

const EditBudget = ({ isOpen, onClose, showData, setResetSearch, title }) => {
    const token = useSelector(state => state.user.userToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const initialState = {
        budget_id: '',
        startPrice: '',
        endPrice: '',
    };

    const [formData, setFormData] = useState(initialState);

    const { budget_id, startPrice, endPrice } = formData;

    useEffect(() => {
        if (showData) {
            setFormData({
                budget_id: showData.id || '',
                startPrice: showData.start_amount || '',
                endPrice: showData.end_amount || '',
            });
        } else {
        }
    }, [showData, isOpen])

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClose = () => {
        setFormData(initialState);
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const body = {
            budget_id: budget_id,
            start_amount: startPrice,
            end_amount: endPrice
        }

        try {
            const result = await ApiHandler('/edit_bike_budget.php', 'POST', body, token, dispatch, navigate)
            if (result.data.status === "1") {
                toast.success(result?.data.msg)
                handleClose();
                setResetSearch(true);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            handleClose();
        }
    };

    return (
        <ModalLarge isOpen={isOpen} title={title} onClose={handleClose} modalWidth={false}>
            <form onSubmit={handleSubmit} className="p-4">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-4'>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            Start Price
                        </label>
                        <input
                            type="number"
                            name="startPrice"
                            value={startPrice}
                            placeholder='Please Enter a Condition'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="userId"
                            className="block text-[#222] font-semibold mb-1"
                        >
                            End Price
                        </label>
                        <input
                            type="number"
                            name="endPrice"
                            value={endPrice}
                            placeholder='Please Enter a Condition'
                            onChange={handleInputChange}
                            required
                            className={`${InputCss}`}
                        />
                    </div>
                </div>

                <FormFooterButton onClick={handleClose} />
            </form>
        </ModalLarge>
    )
}

export default EditBudget;
